import { type FC, type ComponentProps } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import * as styles from "./style.css";

type ButtonProps = ComponentProps<typeof TextButton>;

export const DeleteTextLinkButton: FC<ButtonProps> = ({
  type,
  className,
  onClick,
  children,
  size,
}) => (
  <TextButton
    type={type}
    onClick={onClick}
    className={`${styles.button} ${className ?? ""}`}
    size={size}
  >
    {children}
  </TextButton>
);
